import React from "react";
import Layout from "../../layout/builders/Layout"; // Import the builder layout
import { Briefcase, Clock } from "lucide-react"; // Optional: Using icons for visual appeal

const JobsComingSoon = () => {
  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      {" "}
      {/* Match the background */}
      <Layout>
        <div className="flex flex-col items-center justify-center h-[calc(100vh-10rem)] text-center p-6 bg-white rounded-xl shadow-md mt-4">
          {/* Optional Icon */}
          <div className="relative mb-6">
            <Briefcase className="w-16 h-16 text-blue-400" />
            <Clock className="absolute -bottom-2 -right-2 w-8 h-8 text-orange-400 bg-white rounded-full p-1 shadow-md" />
          </div>

          {/* Main Message */}
          <h2 className="text-3xl font-bold text-gray-800 mb-3">
            Jobs Portal Coming Soon!
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-md">
            We're working hard to bring you a dedicated portal to find
            construction-related job opportunities and connect with talent. Stay
            tuned!
          </p>

          {/* Optional: Maybe a visual divider or element */}
          <div className="w-24 h-1 bg-blue-200 rounded-full"></div>
        </div>
      </Layout>
    </div>
  );
};

export default JobsComingSoon;
